export const team = `
  uuid
  public_name: teamName
  state
`
